import { useTranslation } from "react-i18next";
import styles from "./Login.desktop.module.css";
import { useLoginController } from "../Login.controller";
import InputView from "../../../components/input/Input.view";
import React from "react";
import LoaderView from "../../../components/loader/Loader.view.tsx";
import { getVersion } from "../../../tools/ConfigurationReader.ts";

export default function LoginDesktopView() {
  const { t } = useTranslation();
  const {
    username,
    setUsername,
    password,
    setPassword,
    handleLoginClick,
    loading,
    loginButtonRef,
    usernames,
    handleChipClick,
    passwordRef,
  } = useLoginController();

  return (
    <div className={styles.overlay}>
      <img
        src="/images/login-background.jpg"
        alt={t("ui.altBackground")}
        className={styles.background}
      />

      <div className={styles.container}>
        {loading && (
          <div className={styles.loaderContainer}>
            <LoaderView />
          </div>
        )}

        {!loading && (
          <>
            <div className={styles.logoContainer}>
              <img
                className={styles.logo}
                src="/images/logo.png"
                alt={t("ui.altLogo")}
              />
            </div>

            <div className={styles.inputContainer}>
              <InputView
                placeholder={t("ui.placeholderForEmail")}
                value={username}
                width={300}
                onChange={(e) => setUsername(e.target.value)}
              />
              <div className={styles.space} />
              <InputView
                ref={passwordRef}
                type="password"
                placeholder={t("ui.placeholderForPassword")}
                value={password}
                width={300}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className={styles.space} />
              <button
                className={styles.button}
                onClick={handleLoginClick}
                ref={loginButtonRef}
              >
                {t("ui.login")}
              </button>
            </div>

            <div className={styles.versionContainer}>{getVersion()}</div>

            <div className={styles.usernamesContainer}>
              {usernames &&
                usernames.map((username: string) => (
                  <span
                    key={username}
                    className={styles.usernames}
                    onClick={() => handleChipClick(username)}
                  >
                    {username}
                  </span>
                ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
